@let vm = vm$();

<div class="p-24 h-100 w-100 flex-col gap-16">
  @if (vm.viewState !== 'LOADING' && vm.viewState !== 'INITIAL_EMPTY') {
    <div class="flex-row space-between-start">
      <div class="flex-col gap-16">
        <ui-search
          style="width: 285px"
          [placeholder]="'ENTRANCE.PLACEHOLDERS.SEARCH' | translate"
          [searchQuery]="vm.search"
          (searchQueryChange)="search.set($event)">
        </ui-search>
      </div>
      <ui-button type="secondary" [text]="'ENTRANCE.BUTTONS.CREATE' | translate" (clickAction)="addEntrance()"></ui-button>
    </div>
  }

  @switch (vm.viewState) {
    @case ('LOADING') {
      <div class="h-100 w-100 flex-col center-center">
        <ui-preloader [color]="loaderColor.blue"></ui-preloader>
      </div>
    }
    @case ('INITIAL_EMPTY') {
      <div class="h-100 w-100 flex-col center-center">
        <ui-no-data
          [imgSrc]="noData.imgSrc"
          [title]="noData.title | translate"
          [createButtonText]="noData.createButtonText | translate"
          (onCreate)="addEntrance()">
        </ui-no-data>
      </div>
    }
    @case ('NO_RESULTS') {
      <div class="h-100 w-100 flex-col center-center">
        <ui-no-data [imgSrc]="noResults.imgSrc" [title]="noResults.title | translate"></ui-no-data>
      </div>
    }
    @case ('HAS_DATA') {
      @if (tableConfig()) {
        <ui-dataset-table
          [data]="vm.filteredEntrances"
          [config]="tableConfig()!"
          (rowAction)="onRowAction($event)"
        ></ui-dataset-table>
      }
    }
  }
</div>

<!-- CELL TEMPLATES -->
<ng-template #nameCell let-row>
  @if (camera(row); as cameraData) {
    <div class="flex-row gap-8 start-center">
      <div class="camera-snapshot">
        <ui-camera-snapshot [cameraId]="cameraData.cameraId" [edgeId]="cameraData.edgeId"></ui-camera-snapshot>
      </div>
      <div uiTruncateText>{{ row.name }}</div>
    </div>
  } @else {
    <div uiTruncateText>{{ row.name }}</div>
  }
</ng-template>

